import { useState } from 'react';
import { Tab } from '@headlessui/react';
import { useNavigate } from 'react-router-dom';
import {
  ClipboardDocumentListIcon,
  ShieldExclamationIcon,
  DocumentTextIcon,
  UserIcon,
} from '@heroicons/react/24/outline';
import clsx from 'clsx';
import InitialAssessment from './tabs/InitialAssessment';
import ImpactAnalysis from './tabs/ImpactAnalysis';
import Documentation from './tabs/Documentation';
import EICReview from './tabs/EICReview';

const tabs = [
  { id: 'initial', name: 'Initial Assessment', icon: ClipboardDocumentListIcon },
  { id: 'impact', name: 'Impact Analysis', icon: ShieldExclamationIcon },
  { id: 'documentation', name: 'Documentation', icon: DocumentTextIcon },
  { id: 'eic-review', name: 'Executive-in-Charge Review', icon: UserIcon },
];

export default function IncidentAssessment() {
  const [selectedTab, setSelectedTab] = useState(0);
  const navigate = useNavigate();

  const handleSave = () => {
    navigate('/crisis-response');
  };

  const handleCancel = () => {
    navigate('/crisis-response');
  };

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <h2 className="text-2xl font-bold text-gray-900">Incident Assessment</h2>
        <div className="flex space-x-3">
          <button 
            onClick={handleSave}
            className="px-4 py-2 bg-indigo-600 text-white rounded-md hover:bg-indigo-700"
          >
            Save Assessment
          </button>
          <button 
            onClick={handleCancel}
            className="px-4 py-2 border border-gray-300 rounded-md hover:bg-gray-50"
          >
            Cancel
          </button>
        </div>
      </div>

      <Tab.Group selectedIndex={selectedTab} onChange={setSelectedTab}>
        <Tab.List className="flex space-x-4 border-b border-gray-200">
          {tabs.map((tab) => (
            <Tab
              key={tab.id}
              className={({ selected }) =>
                clsx(
                  'flex items-center space-x-2 py-2 px-4 text-sm font-medium border-b-2 outline-none',
                  selected
                    ? 'border-indigo-500 text-indigo-600'
                    : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                )
              }
            >
              <tab.icon className="h-5 w-5" />
              <span>{tab.name}</span>
            </Tab>
          ))}
        </Tab.List>
        <Tab.Panels>
          <Tab.Panel><InitialAssessment /></Tab.Panel>
          <Tab.Panel><ImpactAnalysis /></Tab.Panel>
          <Tab.Panel><Documentation /></Tab.Panel>
          <Tab.Panel><EICReview /></Tab.Panel>
        </Tab.Panels>
      </Tab.Group>
    </div>
  );
}